import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from "react";
import { AttributeDataType } from "@plansoft-configuration-renderer/configuration-api";
/**
 * Allows access of attribute layout props via context
 */
export const AttributeLayoutContext = createContext({
    identifier: "",
    dataType: AttributeDataType.String,
    viewLevel: 0,
    overrideNumberFormatOptions: false,
    numberFormatOptions: undefined,
    wrapperSx: undefined,
    visibleInNavigation: false,
});
AttributeLayoutContext.displayName = "AttributeLayoutContext";
export function AttributeLayoutProvider(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    const options = useMemo(() => {
        return Object.assign({}, props);
    }, [props]);
    return (_jsx(AttributeLayoutContext.Provider, { value: options, children: children }));
}
/**
 * Allows additional specifying default properties
 * @category Hook
 * @param defaultProps
 * @returns
 */
export function useAttributeLayoutBaseProps() {
    const layoutProps = useContext(AttributeLayoutContext);
    return layoutProps;
}
//# sourceMappingURL=AttributeLayoutContext.js.map